import { render, staticRenderFns } from "./ImportHistoryStatusBadge.vue?vue&type=template&id=ddac148c"
import script from "./ImportHistoryStatusBadge.vue?vue&type=script&lang=js"
export * from "./ImportHistoryStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports